if ('scrollBehavior' in document.documentElement.style === false) {
  import(
    /* webpackChunkName: "smooth-scroll-polyfill" */ 'smoothscroll-polyfill'
  ).then(({ default: smoothscroll }) => {
    smoothscroll.polyfill()
  })
}
